import React from 'react';
import { motion } from 'framer-motion';
import { FaLightbulb, FaExpandArrowsAlt, FaShieldAlt, FaUsers } from 'react-icons/fa';

const features = [
  {
    icon: <FaLightbulb className="text-cyan-400 w-8 h-8" />, 
    title: 'Innovation Focused',
    desc: 'Constantly pushing the boundaries of technology.',
  },
  {
    icon: <FaExpandArrowsAlt className="text-cyan-400 w-8 h-8" />, 
    title: 'Scalable Architecture',
    desc: 'Built to grow with your needs.',
  },
  {
    icon: <FaShieldAlt className="text-cyan-400 w-8 h-8" />, 
    title: 'Secure & Reliable Systems',
    desc: 'Security is integrated from the ground up.',
  },
  {
    icon: <FaUsers className="text-cyan-400 w-8 h-8" />, 
    title: 'Community-Centered Technology',
    desc: 'Solutions designed for people and communities.',
  },
];

const WhyChoose = () => {
  return (
    <section id="why" className="py-20 px-6 bg-gray-800 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <h2 className="text-3xl font-bold">Why Choose Us</h2>
      </motion.div>
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((f, idx) => (
          <motion.div
            key={idx}
            whileHover={{ scale: 1.03 }}
            className="bg-gray-900 p-6 rounded-lg shadow-lg flex flex-col items-center text-center space-y-4"
          >
            {f.icon}
            <h3 className="text-xl font-semibold">{f.title}</h3>
            <p className="text-gray-300">{f.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;
